import {getPublishedCollection} from '@wix/music-shared/dist/src/getPublishedCollection';
import {sendRequest} from '@wix/music-shared/dist/src/utils/send-request';
import {MusicAlbumCollection} from '@wix/music-shared/typings/music-collection';
import {injectable, decorate} from 'inversify';
import {RawLegacyData} from '../CollectionManager/types';
import {ICollectionFetcher} from './ICollectionFetcher';

export class CollectionFetcher implements ICollectionFetcher {
  fetchCollection(collectionId: string, metaSiteId: string | null = null): Promise<MusicAlbumCollection> {
    return getPublishedCollection({
      id: collectionId,
      metaSiteId,
    });
  }

  async fetchLegacyCollection(instanceId: string, compId: string): Promise<RawLegacyData> {
    const response = await sendRequest({
      url: `//static.wixstatic.com/legacy-player/${instanceId}-${compId}.json`,
    });
    return response.data;
  }
}

decorate(injectable(), CollectionFetcher);
